import { LBtn } from "@components";
import { useModal } from "@services/ModalContext";
import { NewExamineeStepNames } from "../store/newExamineeSlice";

export const NewAssessmentFooter = ({
    loading,
    saveButtonText = "Save to Upcoming"
}: NewAssessmentFooterProps): JSX.Element => {
    const { closeModal, formName } = useModal();

    return (
        <div className="is-flex is-flex-direction-row is-justify-content-space-between">
            <LBtn variation="unstyled" onClick={closeModal} isBold>
                {formName === NewExamineeStepNames.ContactInfo ? "Cancel" : "< Back"}
            </LBtn>
            <LBtn type="submit" form={formName} isBold loading={loading}>
                {formName === NewExamineeStepNames.AssignedTo ? saveButtonText : "Next"}
            </LBtn>
        </div>
    );
};

interface NewAssessmentFooterProps {
    loading?: boolean;
    saveButtonText?: string;
}
